import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DryerDTO, DryerGroup, FormValues, ModelDTO, PayloadDto, PayloadSensorValues, ProductDTO } from '../models';
import { Images } from '../models/file.model';
import { Product } from '../models/product.model';

@Injectable()
export class ProductRepository {
  constructor(private http: HttpClient) {}

  getProducts(): Observable<Product[]> {
    const url = environment.products.get;
    return this.http.get<Product[]>(url);
  }
  getImages(): Observable<Images[]> {
    const url = environment.images.get;
    return this.http.get<Images[]>(url);
  }

  getImagePathUsingDryerGroup(dryerGroup: DryerGroup): Observable<Images> {
    const url = environment.images.getImagePath;
    const params = new HttpParams().set('dryerGroup', dryerGroup);
    return this.http.get<Images>(url, { params: params });
  }

  getDryerTypes(): Observable<string> {
    const url = environment.dryersTypes.get;
    return this.http.get<string>(url);
  }
  fetchFields(payload: DryerDTO[]): Observable<Map<string, object>> {
    const url = environment.products.fields.fetch;
    return this.http.post<Map<string, object>>(url, payload);
  }

  fetchExactModels(models: PayloadDto): Observable<ModelDTO[]> {
    const url = environment.products.exactModel;
    return this.http.post<ModelDTO[]>(url, models);
  }

  getAllModels(): Observable<string[]> {
    const url = environment.getAllModels.get;
    return this.http.get<string[]>(url);
  }

  fetchSpecificModel(body: FormValues, specificModel: string): Observable<ModelDTO[]> {
    let url = environment.products.specificModel;
    url = url.replace('{specificModel}', specificModel);

    return this.http.post<ModelDTO[]>(url, body);
  }

  fetchSuggestedModels(suggestedModel: ProductDTO): Observable<Map<string, object>> {
    const url = environment.products.suggestModel;
    return this.http.post<Map<string, object>>(url, suggestedModel);
  }

  fetchModelNames(params: any): Observable<string[]> {
    const url = environment.getAllModels.post;
    return this.http.post<string[]>(url, params);
  }
  fetchActualModelImagePath(modelName: string): Observable<string> {
    const url = environment.images.getActualModelImagePath;
    const params = new HttpParams().set('modelName', modelName);

    return this.http.get(url, { params, responseType: 'text' });
  }

  fetchFormula(valueType: string, sourceUnit: string, targetUnit: string): Observable<string> {
    const url = environment.units.formulas;
    const params = new HttpParams().set('valueType', valueType).set('sourceUnit', sourceUnit).set('targetUnit', targetUnit);
    return this.http.get<any>(url, { params }).pipe(map((res) => res?.formula));
  }

  getDownloadPdf(modelName: string, isHeaterRequired: boolean, fetchSensorValues: PayloadSensorValues): Observable<HttpResponse<Blob>> {
    const locale = 'en';
    let url = environment.products.downloadPdf;
    const headers = new HttpHeaders({
      Accept: 'application/pdf',
    });
    url = url.replace('{modelName}', modelName);
    const params = new HttpParams().set('modelName', modelName).set('locale', locale).set('isHeaterRequired', isHeaterRequired);
    return this.http.post(url, fetchSensorValues, {
      headers,
      params,

      observe: 'response',
      responseType: 'blob',
    });
  }
}
